var i;!function(i){i[i.bestFit=0]="bestFit",i[i.flipfit=1]="flipfit",i[i.ignore=2]="ignore"}(i||(i={}));export{i as CollisionHandler};
//# sourceMappingURL=CollisionHandler.m.js.map
